import React from "react";
import { node } from "prop-types";
import {
	spacingClassName,
	spacingProps,
	spacingPropTypes,
} from "@insightfulscience/atomic-react/props/spacing";
import { classes } from "@insightfulscience/atomic-react/utils/classes";

const PageNavbarItem = ({ spacing = { ...spacingProps }, children }) => (
	<div className={classes("page-navbar-item", ...spacingClassName(spacing))}>{children}</div>
);

PageNavbarItem.propTypes = {
	spacing: spacingPropTypes,
	children: node,
};

export default PageNavbarItem;
